<template>
	<div id="app">
		<img src="./assets/2024_01.jpg" alt="" />
		<img src="./assets/2024_02.jpg" alt="" />
		<img src="./assets/2024_03.jpg" alt="" />
		<img src="./assets/2024_04.jpg" alt="" />
		<img src="./assets/2024_05.jpg" alt="" />
		<div class="bottom" @click="next">
			网站备案信息：辽ICP备2024024908号
		</div>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {

		},
		methods: {
			next() {
				window.open("https://beian.miit.gov.cn/#/Integrated/index", '_blank');
			}
		}
	}
</script>

<style>
	body {
		margin: 0;
		padding: 0;
	}

	#app {}


	img {
		width: 100%;
		vertical-align: bottom;
	}

	.bottom {
		width: 100%;
		text-align: center;
		height: 60px;
		line-height: 60px;
		color: #3333333;
		cursor: pointer;
	}

	::-webkit-scrollbar {
		display: none;
	}
</style>